module.exports = "<template> <div> <select class=form-control ref=select style=width:100% multiple=multiple></select> </div> </template> ";